<template>
  <div class="view-tool-detail">
    <b-container class="hero-container header">
      <b-row>
        <b-col md="6" class="hero-text border-bottom pb-20 mb-20 pb-md-0 mb-md-0">
          <!-- <h6 class="text-gray-700 pb-20">Resources</h6> -->

          <h1 class="pb-40">{{ tool.title }}</h1>

          <p class="fs20 text-gray-700">{{ tool.subTitle }}</p>

          <h3 class="pb-40 tools_page_detail-comment">{{ tool.comment }}</h3>
        </b-col>

        <b-col v-if="tool.image && tool.image" md="6">
          <div class="hero-image">
            <img class="image" :src="tool.image.largeSizeUrl" alt="" />
            <img
              v-if="tool.partnerLogo"
              class="logo"
              :src="
                tool && tool.partnerLogo && tool.partnerLogo.thumbnailSizeUrl
                  ? tool.partnerLogo.thumbnailSizeUrl
                  : ''
              "
              alt=""
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
    <Container width="medium" spacing="medium" border-bottom>
      <TextBlock>
        <b-row>
          <b-col>
            <div class="richtext-content" v-html="tool.text"></div>
          </b-col>
        </b-row>
      </TextBlock>
    </Container>
    <Container width="medium" spacing="medium">
      <TextBlock class="mt-0">
        <ToolsForm v-if="tool.isExtended || tool.isDownloadable" :tool="tool" />
        <b-row v-else>
          <b-col lg="8">
            <h3 class="fs40">{{ tool.requestHeadline }}</h3>

            <div class="richtext-content pb-24" v-html="tool.requestText"></div>

            <a v-if="tool.link" :href="tool.link" target="_blank" class="btn" @click="onLinkClick">
              {{ tool.buttonText }}
            </a>
          </b-col>
        </b-row>
      </TextBlock>
    </Container>
  </div>
</template>

<script>
import ToolsForm from './ToolsForm';
import Container from '@/components/Container';
import TextBlock from '@/components/TextBlock';

export default {
  components: {
    ToolsForm,
    Container,
    TextBlock
  },
  props: {
    tool: {
      type: Object,
      required: true
    }
  },
  methods: {
    onLinkClick() {
      this.$gtm.push({
        event: 'ga.event',
        category: 'tool',
        action: 'ToolLinkClick'
      });

      this.$engagement({
        type: 'tool.linkClick'
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.tools_page_detail-comment {
  margin-top: 2rem;
}
.header {
  position: relative;

  @include media-breakpoint-up(xl) {
    max-width: 1360px !important;
  }

  .hero-text {
    display: flex;
    min-height: 100%;
    flex-direction: column;
    justify-content: center;

    h6 {
      font-weight: normal;
    }
  }

  .hero-image {
    position: relative;

    .image {
      width: 100%;
      height: 560px;
      object-fit: cover;
    }

    .logo {
      position: absolute;
      background-color: #fff;
      bottom: 0;
      left: 0;
      width: rem(100px);
      height: rem(100px);
      object-fit: contain;
    }
  }

  @include media-breakpoint-only(md) {
    .hero-image {
      .image {
        height: 400px;
      }
    }
  }

  @include media-breakpoint-down(sm) {
    .hero-image {
      .image {
        height: 300px;
      }
    }
  }
}
</style>
